// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// ✅ JSON imports
import en from "./locales/en/common.json";
import hi from "./locales/hi/common.json";
import gu from "./locales/gu/common.json";

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  gu: { translation: gu },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    fallbackLng: "en",

    // ✅ important for hi-IN / gu-IN etc.
    supportedLngs: ["en", "hi", "gu"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",

    interpolation: { escapeValue: false },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    // ✅ avoids returning key name if missing
    returnEmptyString: false
  });

export default i18n;
